import { render } from "./SvgLoader.vue?vue&type=template&id=18ad555c"
import script from "./SvgLoader.vue?vue&type=script&lang=js"
export * from "./SvgLoader.vue?vue&type=script&lang=js"

import "./SvgLoader.vue?vue&type=style&index=0&id=18ad555c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__